(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilderLodgingPhotos',
	};

	var selected_images = [],
		total_photos    = $('.photo-count').data('initial-value');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.fit-builder-hotel-image').click(function _selectHotel() {
			var image,
				src = $(this).data('src');

			if ($(this).hasClass('fit-builder-hotel-images-active')) {
				$(this).removeClass('fit-builder-hotel-images-active');

				image = selected_images.indexOf(src);

				if (image > -1) {
					selected_images.splice(image, 1);
				}

			} else {
				selected_images.push(src);

				$(this).addClass('fit-builder-hotel-images-active');
			}

			if (selected_images.length > 0) {
				$('.photo-count').html(total_photos + ' - Selected ' + selected_images.length);
			} else {
				$('.photo-count').html(total_photos);	
			}

			$('#fitbuilderlodgingphotos-image_url').val(JSON.stringify(selected_images));
		});

	};
}(jQuery, window.Adzuki || {}));